
<template>
        <div class="form-group">
            <label >{{labelName}}</label>
            <l-input v-on:input="updateValue()"  ref="input" :placeholder="placeholder" v-bind:value="value" :error="error" :j="error" :isCheck="isCheck"></l-input>
        </div>
</template>

<script>

import propsync from '../../propsync';//引入mixin文件
export default {
    mixins: [propsync],//声明使用propsync的mixin
    props: ['placeholder', 'error', 'j','value', 'isCheck','labelName'],
    data() {
        return {
        }
    },
    methods: {
        change:function(propName,newVal,oldVal){
            this[propName]=newVal;
            console.log("组件tab的" +propName+ "属性变更为" +newVal);
        },
         updateValue: function () {
            this.$emit('input', this.$refs.input.currentValue)
        }
    }
}

</script>







// WEBPACK FOOTER //
// form_group.vue?374f8ae8